
<div  class="pdf-print-view" [innerHTML]="jvData">
</div>
<div style="margin-top:20px; text-align: center;" class="d-flex justify-content-center">
	<button class="btn-style bg-green no-print" (click)="downloadPdf(jvId)">Print</button>
</div>
